import { getRatios } from "./index148.js";
const getFlatCombination = ({ flats, distribution, space, distCalc = getRatios, gap }) => {
	const count = Array(flats.length).fill(0);
	getDynamicFlatCombination({
		count,
		flats,
		distribution,
		space,
		distCalc,
		gap
	});
	return count;
};
var getDynamicFlatCombination = ({ flats, distribution, space, count = Array(flats.length).fill(0), distCalc = getRatios, gap }) => {
	let next = -1;
	let currLength = 0;
	do {
		next = GetNextDistributionItem({
			count,
			distribution,
			distCalc
		});
		count[next]++;
		currLength = getObjsLength(count, flats, gap);
	} while (currLength < space);
	if (currLength > space) count[next]--;
	return count;
};
var GetNextDistributionItem = ({ count, distribution, distCalc }) => {
	const diffs = distCalc(count).map((c, i) => c - distribution[i]);
	let lowestIndex = 0;
	for (let i = 1; i < diffs.length; i++) if (diffs[i] < diffs[lowestIndex]) lowestIndex = i;
	return lowestIndex;
};
var getObjsLength = (count, apartments, gap) => {
	return apartments.reduce((sum, a, i) => sum + (a.size[0] * count[i] + gap * count[i]), 0);
};
export { getFlatCombination };

//# sourceMappingURL=index191.js.map